if (!customElements.get('product-media-layout')) {
  customElements.define('product-media-layout', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-product-media-layout]');
      if (!this.root) return;
      this.mediaQuery = window.matchMedia('(min-width: 1068px)');
      this.updateLayout = this.updateLayout.bind(this);
      this.mediaQuery.addEventListener('change', this.updateLayout);
      this.updateLayout();
    }

    disconnectedCallback() {
      this.mediaQuery?.removeEventListener('change', this.updateLayout);
    }

    updateLayout() {
      const layout = this.mediaQuery.matches ? this.root.dataset.desktopMediaLayout : this.root.dataset.mobileMediaLayout;
      const container = this.root.querySelector('.product-image-container');
      let slider = container.querySelector('.product-images');
      const tagName = layout === 'thumbnails' ? 'product-slider-thumbnails' : 'product-slider';
      const layouts = ['slider', 'grid', 'list', 'collage', 'thumbnails'];

      this.root.dataset.activeMediaLayout = layout;
      container.classList.remove(...layouts.map(value => `product-image-container--${value}`));
      container.classList.add(`product-image-container--${layout}`);

      if (slider.localName !== tagName) {
        // Destroy Flickity before copying slides so no viewport or positioning styles survive.
        const selectedMediaId = slider.flkty?.selectedElement?.dataset.mediaId;
        slider.flkty?.destroy();
        slider.flkty = null;
        const replacement = document.createElement(tagName);
        Array.from(slider.attributes).forEach(({ name, value }) => replacement.setAttribute(name, value));
        Array.from(slider.children).forEach(child => replacement.appendChild(child.cloneNode(true)));
        replacement.querySelectorAll('[data-zoom-click-bound]').forEach(media => delete media.dataset.zoomClickBound);
        if (selectedMediaId) {
          replacement.querySelectorAll('[data-media-id]').forEach(slide => {
            slide.classList.toggle('is-initial-selected', slide.dataset.mediaId === selectedMediaId);
          });
        }
        const thumbnails = container.querySelector('.product-thumbnail-container');
        if (thumbnails) {
          const nextThumbnails = thumbnails.cloneNode(true);
          // Normal galleries move variant media to the front. Keep thumbnail order and visibility in sync.
          replacement.querySelectorAll('[data-media-id]').forEach(slide => {
            const thumbnail = Array.from(nextThumbnails.children).find(thumb => thumb.id === slide.id.replace('Slide-', 'Thumb-'));
            if (!thumbnail) return;
            thumbnail.classList.toggle('is-active', slide.classList.contains('is-active'));
            thumbnail.classList.toggle('is-initial-selected', slide.classList.contains('is-initial-selected'));
            nextThumbnails.appendChild(thumbnail);
          });
          thumbnails.replaceWith(nextThumbnails);
        }
        const pagination = container.querySelector('.product-images-buttons');
        if (pagination) pagination.replaceWith(pagination.cloneNode(true));
        replacement.classList.remove(...layouts.map(value => `product-images--${value}`));
        replacement.classList.add(`product-images--${layout}`);
        slider.replaceWith(replacement);
        slider = replacement;
      } else {
        slider.classList.remove(...layouts.map(value => `product-images--${value}`));
        slider.classList.add(`product-images--${layout}`);
        slider.onPaginationResize?.();
      }

      // Variant pickers cache the gallery element; keep those references current after a swap.
      this.root.querySelectorAll('variant-selects').forEach(picker => {
        picker.productSlider = slider;
        picker.thumbnails = layout === 'thumbnails' ? container.querySelector('.product-thumbnail-container') : null;
      });
    }
  });
}
